var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHammer = function SvgHammer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.504,
    cy: 44.058,
    r: 39.222,
    fill: "#fff",
    stroke: "#A7A398"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.13 70.415h4.441a.746.746 0 0 0 .512-.21.691.691 0 0 0 .21-.495V38.383h-5.855V69.71a.69.69 0 0 0 .214.498.747.747 0 0 0 .517.207",
    fill: "#002A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.796 26.126V24.06a.572.572 0 0 0-.18-.418.617.617 0 0 0-.435-.173h-6.187c-6.13 0-12.259 2.817-15.265 4.423a.6.6 0 0 0-.266.285.571.571 0 0 0-.029.382c.035.127.112.239.22.319.109.08.241.122.378.122h7.808l4.294.056a.617.617 0 0 1 .424.171.57.57 0 0 1 .171.412v6.16c0 .182.075.356.209.484.134.13.315.201.504.201h7.661c.19 0 .37-.072.504-.2a.673.673 0 0 0 .209-.485v-9.673h-.02Z",
    fill: "#5C8283"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.294 68.148h-5.856v1.747c0 .136.055.265.153.362a.547.547 0 0 0 .373.155h4.88a.547.547 0 0 0 .374-.155.506.506 0 0 0 .153-.362l-.078-1.747Z",
    fill: "#BC5C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.797 32.586h3.27c.642 0 1.277.13 1.865.378a4.636 4.636 0 0 1 1.55 1.069l.615.666h5.388a.816.816 0 0 0 .56-.229.756.756 0 0 0 .23-.54v-9.176a.756.756 0 0 0-.23-.54.816.816 0 0 0-.56-.23h-5.388l-.615.667c-.434.456-.962.82-1.55 1.069a4.792 4.792 0 0 1-1.866.377h-3.27v6.49Z",
    fill: "#5C8283"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.734 36.453h-6.773v1.653a.24.24 0 0 0 .074.172.259.259 0 0 0 .18.072h6.266a.259.259 0 0 0 .179-.072.24.24 0 0 0 .074-.172v-1.653Z",
    fill: "#BC5C41"
  })));
};
export default SvgHammer;